import { put, takeLeading } from 'redux-saga/effects';
import { get } from 'lodash';
import { callApi } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';
import {
  REQUEST_CREATE_INTERVENANT_KEYCLOAK,
  REQUEST_GET_MAPPING_LAWYERS,
  REQUEST_UPDATE_MAPPING_LAWYERS,
  REQUEST_SEARCH_MAPPING_LAWYERS,
  REQUEST_GET_MAPPING_LAWYER,
} from 'containers/IntervenantManagement/constants';

import {
  setMappingLawyers,
  setMappingLawyer,
  requestGetMappingLawyers,
} from 'containers/IntervenantManagement/actions';

export function* makeRequestGetMappingLawyers(action: any): Generator {
  const { page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/mapping-lawyer-jurisdiction?page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setMappingLawyers);
}

export function* requestGetMappingLawyersSaga() {
  yield takeLeading(REQUEST_GET_MAPPING_LAWYERS, makeRequestGetMappingLawyers);
}
export function* requestCreateIntervenantKeycloak(action: {
  type: string;
  payload: any;
  successCallBack: Function;
}): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/intervenant`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...action.payload }),
  };
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield action.successCallBack();
  }
}

export function* requestCreateIntervenantKeycloakSaga() {
  yield takeLeading(
    REQUEST_CREATE_INTERVENANT_KEYCLOAK,
    requestCreateIntervenantKeycloak,
  );
}

export function* requestUpdateMappingLawyers(action: {
  type: string;
  payload: any;
  successCallBack: Function;
}): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/mapping-lawyer-jurisdiction`;
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(action.payload),
  };
  const errorResponse = yield callApi(path, {}, options, []);
  if (!errorResponse) {
    yield action.successCallBack();
    yield put(requestGetMappingLawyers(0, 25));
  }
}

export function* requestUpdateMappingLawyersSaga() {
  yield takeLeading(
    REQUEST_UPDATE_MAPPING_LAWYERS,
    requestUpdateMappingLawyers,
  );
}

export function* requestSearchMappingLawyers(action: {
  type: string;
  payload: any;
  successCallBack: Function;
}): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/mapping-lawyer-jurisdiction/search`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(action.payload),
  };
  yield callApi(path, {}, options, [], setMappingLawyers);
}

export function* requestSearchMappingLawyersSaga() {
  yield takeLeading(
    REQUEST_SEARCH_MAPPING_LAWYERS,
    requestSearchMappingLawyers,
  );
}

export function* requestMappingLawyer(action: {
  type: string;
  payload: any;
}): Generator<unknown> {
  const token = get(userToken.get(), 'token');
  if (!token) return;
  const path = `/corporeal/mapping-lawyer-jurisdiction/search`;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(action.payload),
  };
  yield callApi(path, {}, options, [], setMappingLawyer);
}

export function* requestMappingLawyerSaga() {
  yield takeLeading(REQUEST_GET_MAPPING_LAWYER, requestMappingLawyer);
}
export default [
  requestGetMappingLawyersSaga,
  requestCreateIntervenantKeycloakSaga,
  requestUpdateMappingLawyersSaga,
  requestSearchMappingLawyersSaga,
  requestMappingLawyerSaga,
];
